import React, { useContext, useEffect, useState } from "react";
import StoreMenu from "../../StoreMenu";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserData } from "../../../utils/localStorage";
import { ProgressSpinner } from "primereact/progressspinner";
import { getWarehouseStoreById } from "../../../services/warehouse/WarehouseWithStore";
import { getBrandStore, getBrandUsers } from "../../../services/StoreUsers/PostStoreUsers";
import WarehouseStoreStatusChange from "./WarehouseStoreStatusChange";
import WarehouseStoreAddModal from "./WarehouseStoreAddModal";
import { getWarehouseStageUsers } from "../../../services/WarehouseStage/WarehouseStageUsers";
import { getWarehouseUser } from "../../../services/warehouse/WarehouseWithUser";
import WarehouseProcessUserStatusChange from "./WarehouseProcessUserStatusChange";
import WarehouseStageUserAddModal from "./WarehouseStageUserAddModal";
import AdminMenu from "../../AdminMenu";


const WarehouseProcessStageUsers = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = location.state || {}; // Fallback to prevent undefined errors

  const [visible, setVisible] = useState(false);
  const [modalMenuVisible, setModalMenuVisible] = useState(false);
  const [userList, setUserList] = useState([]);

  const [
    warehouseStageUserAddModalVisible,
    setWarehouseStageUserAddModalVisible,
  ] = useState(false);

  const handleConfirmAndContinue = () => {
    setModalMenuVisible(true);
  };
  const [loadingStore, setLoadingStore] = useState(false);
  const [loadingUser, setLoadingUser] = useState(false);

  const [warehouseStageUserData, setWarehouseStageUserData] = useState([]);
  const [warehouseUserData, setWarehouseUserData] = useState([]);
   
  
  const { brandProfileData } = getUserData();
  let brandId = brandProfileData.id;

  const fetchData = () => {
    // getWarehouseStore(brandId)
    setLoadingStore(true);

    getBrandUsers(brandId)
      .then(response => {
        if (!response.data.error) {
          const users = response.data;
          setUserList(users);
        }
      })
      .catch(err => {
        console.error('Error:', err);
      });

    getWarehouseStageUsers(id)
      .then(response => {
        if (!response.data.error) {
          const stageUsers = response.data;
          setWarehouseStageUserData(stageUsers);
          //  setUserList(users);
        }
      })
      .catch(err => {
        console.error('Error:', err);
      });
  };


    const fetchUserData = () => {
      setLoadingUser(true);
      getWarehouseUser(brandId, id)
        .then(response => {
          if (!response.data.error) {
            const Res = response.data;
            setWarehouseUserData(Res);
            setLoadingUser(false);
          }
        })
        .catch(err => {
          console.error('Error:', err);
        });
    };


  useEffect(() => {
    fetchData();
    fetchUserData();
  }, []);

  const receiveDataFromBrandWarehouseStoreUserStatusChange = ({success}) => {
    if (success) {
      fetchData();
    }
  };
  const renderWarehouseStoreCardItem = (data) => {
    return data?.map((item, index) => {
      return (
        <div>
          <div className="flex-1 ">
            <div className="m-4 shadow-4">
              <div className="flex flex-1">
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Stage :
                  </p>
                  <p className="text-lg font-medium capitalize">
                  {item.wareHouseGarmentProcessStage.stage}
                  </p>
                </div>
                 
                <div
                  className="flex-1 px-3 py-1 flex justify-content-between"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <div>
                    <p
                      className="text-md font-normal capitalize"
                      style={{ color: "#75879B" }}
                    >
                      Status
                    </p>
                    <p className="text-lg font-medium capitalize">{item.status === true ? 'Active' : 'DeActive'}{' '}</p>
                  </div>
                  <WarehouseProcessUserStatusChange
                      status={item.status}
                      sendDataToWarehouseConfig={
                        receiveDataFromBrandWarehouseStoreUserStatusChange
                      }
                      editData={item}
                      brandId={brandId}
                      warehouseId={id}
                    />
                </div>
              </div>
              <div className="flex flex-1">
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Warehouse User :
                  </p>
                  <p className="text-lg font-medium capitalize">
                  {item.wareHouseUser.user.firstName +
                      ' ' +
                      item.wareHouseUser.user.lastName}
                  </p>
                </div>
                 
                <div
                  className="flex-1 px-3 py-1 flex justify-content-between"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <div>
                    <p
                      className="text-md font-normal capitalize"
                      style={{ color: "#75879B" }}
                    >
                      Warehouse Name
                    </p>
                    <p className="text-lg font-medium capitalize">{item.wareHouseGarmentProcessStage.wareHouse.name}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() =>
                    navigate("/WarehouseManagementList", {
                      state: {
                        id: id,
                      },
                    })
                  }
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
              WAREHOUSE CONFIG
              </p>
            </div>
          </div>
          <div
            className="flex justify-content-center align-items-center cursor-pointer mr-4"
            onClick={() => {
              setWarehouseStageUserAddModalVisible(true);
            }}
          >
            <img src="images/plus.png" alt="plus" style={{width:30}}/>
          </div>
          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div>
        {loadingUser ? (
          <div style={{ flex: 1 }}>
            <div className="text-center">
              <ProgressSpinner
                style={{ width: "70px", height: "70px" }}
                strokeWidth="4"
                fill="var(--surface-ground)"
                animationDuration="2s"
              />
            </div>
          </div>
        ) : warehouseStageUserData?.length > 0 ? (
          <div>
          <div
            className="flex-1  surface-0"
            style={{ "--surface-0": "#EAEFF5" }}
          >
            <div className="flex justify-content-between mx-4">
              <div className="py-1">
                <p className=" text-2xl  font-bold ">MAPPED WAREHOUSE USER</p>
              </div>
              </div>
              </div>

            <div>{renderWarehouseStoreCardItem(warehouseStageUserData)}</div>
          </div>
        ) : (
          <div className="flex justify-content-center align-items-center">
            <p className="text-xl font-medium">No Warehouse Data Present</p>
          </div>
        )}
      </div>
      <WarehouseStageUserAddModal
          warehouseStageUserAddModalVisible={warehouseStageUserAddModalVisible}
          setWarehouseStageUserAddModalVisible={
            setWarehouseStageUserAddModalVisible
          }
          sendDataToWarehouseConfig={
            receiveDataFromBrandWarehouseStoreUserStatusChange
          }
          brandId={brandId}
          warehouseId={id}
          userList={warehouseUserData}
        />

      <AdminMenu setVisible={setVisible} visible={visible} />
    </div>
  );
};

export default WarehouseProcessStageUsers;
